import { Button as AntdButton } from 'antd';
import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  padding: 0 20px 20px;
  box-sizing: border-box;
`;

export const AgreementWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-top: 20px;
  gap: 8px;
`;

export const AgreementLabel = styled.p`
  & span {
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px;
  }
  margin: 0;
`;

export const TnCWrapper = styled.div`
  position: relative;
  border: 1px solid #ededed;
  border-radius: 4px;
  height: 450px;
`;

export const TnCLoadingWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(255, 255, 255, 0.9);
  z-index: 10;
`;

export const TnCFrame = styled.iframe`
  border: none;
  border-radius: 4px;
  width: 100%;
  height: 100%;
  max-height: 445px;
`;

export const AgreementTextWrapper = styled.div`
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
`;

export const ActionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px 0 0;
`;

interface IButtonProps {
  disabled?: boolean;
}

export const NextButton = styled(AntdButton) <IButtonProps>`
  width: 100%;
  height: 40px;
  border-radius: 4px;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  cursor: pointer;

  &:disabled {
    background-color: #cceee1 !important;
    color: #ffffff !important;
  }
`;
